import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCockpitApi } from '@/api/provider';

export function useOrderForfeit() {
  const api = useCockpitApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { id: string; reason: string; skipCustomerAcknowledgement: boolean }) =>
      api.forfeitOrder(input.id, {
        reason: input.reason,
        skipCustomerAcknowledgement: input.skipCustomerAcknowledgement,
      }),
    onSuccess: (data, variables) => {
      qc.setQueryData(['cockpit', 'exception', variables.id], data);
      void qc.invalidateQueries({ queryKey: ['cockpit', 'queue'] });
      void qc.invalidateQueries({ queryKey: ['cockpit', 'exceptions'] });
    },
  });
}

export function useInboundUpload() {
  const api = useCockpitApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => api.uploadInboundDocument(file),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['cockpit', 'queue'] });
      void qc.invalidateQueries({ queryKey: ['cockpit', 'exceptions'] });
      void qc.invalidateQueries({ queryKey: ['cockpit', 'drafts'] });
    },
  });
}
